import React from 'react'
import { ThemeProvider } from '@mui/material/styles'
import { I18n } from 'aws-amplify'
import { BrowserRouter } from 'react-router-dom'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import itLocale from 'date-fns/locale/it'

import theme from './theme'
import MainRouter from './MainRouter'
import './i18n'
import './App.css'
import SnackbarProvider from './components/organisms/Snackbar'
import { AuthContextProvider } from './auth'
import { defaultLanguage } from './i18n'

I18n.setLanguage(defaultLanguage)

function App() {
  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <LocalizationProvider
          dateAdapter={AdapterDateFns}
          adapterLocale={itLocale}
        >
          <AuthContextProvider>
            <SnackbarProvider>
              <BrowserRouter>
                <MainRouter />
              </BrowserRouter>
            </SnackbarProvider>
          </AuthContextProvider>
        </LocalizationProvider>
      </ThemeProvider>
    </div>
  )
}

export default App
